// extracted by mini-css-extract-plugin
export default {"container":"ModalTitle_container__vH2nw","title":"ModalTitle_title__j-B8g","actions":"ModalTitle_actions__SOC+T","action-btn":"ModalTitle_action-btn__EXpp8"};